import { ReportData } from '../types/reportTypes';

// August 2025 Sales Data - Standard Report (32 jobs from CSV)
const jobData = [
  {
    jobInfo: "E-576: Barbara Wilson",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 16472.00,
    grossMarginPct: 0.5164,
    grossProfit: 8506.14,
    commissionPercentage: 7.00,
    salesCommission: 1153.04,
    salesManagerFee: 164.72,
    companyOH: 2553.16,
    netProfit: 0
  },
  {
    jobInfo: "E-574: Dan Honig",
    leadSource: "Thumbtack",
    trade: "Siding",
    contractTotal: 7472.00,
    grossMarginPct: 0.4305,
    grossProfit: 3216.70,
    commissionPercentage: 4.00,
    salesCommission: 298.88,
    salesManagerFee: 74.72,
    companyOH: 1158.16,
    netProfit: 0
  },
  {
    jobInfo: "E-573: Robyn Barnhart",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 19647.00,
    grossMarginPct: 0.6518,
    grossProfit: 12805.91,
    commissionPercentage: 10.00,
    salesCommission: 1964.70,
    salesManagerFee: 196.47,
    companyOH: 3045.29,
    netProfit: 0
  },
  {
    jobInfo: "E-559: Brandon Duffy",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 24762.65,
    grossMarginPct: 0.4532,
    grossProfit: 11222.43,
    commissionPercentage: 4.00,
    salesCommission: 990.51,
    salesManagerFee: 247.63,
    companyOH: 3838.21,
    netProfit: 0
  },
  {
    jobInfo: "E-575: Jeff & Sue hubbard",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 9079.00,
    grossMarginPct: 0.5784,
    grossProfit: 5251.29,
    commissionPercentage: 7.00,
    salesCommission: 635.53,
    salesManagerFee: 90.79,
    companyOH: 1407.25,
    netProfit: 0
  },
  {
    jobInfo: "E-556: Juliana Gerrick",
    leadSource: "Referral - Word of mouth",
    trade: "Roofing",
    contractTotal: 18151.15,
    grossMarginPct: 0.4674,
    grossProfit: 8483.85,
    commissionPercentage: 4.00,
    salesCommission: 726.05,
    salesManagerFee: 181.51,
    companyOH: 2813.43,
    netProfit: 0
  },
  {
    jobInfo: "E-585: Ronald & Laurie Bartkowiak",
    leadSource: "Thumbtack",
    trade: "Entry Doors",
    contractTotal: 3486.00,
    grossMarginPct: 0.5866,
    grossProfit: 2044.89,
    commissionPercentage: 7.00,
    salesCommission: 244.02,
    salesManagerFee: 34.86,
    companyOH: 540.33,
    netProfit: 0
  },
  {
    jobInfo: "E-565: Elgin & Angela Klugh",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 17872.00,
    grossMarginPct: 0.5144,
    grossProfit: 9193.36,
    commissionPercentage: 7.00,
    salesCommission: 1251.04,
    salesManagerFee: 178.72,
    companyOH: 2770.16,
    netProfit: 0
  },
  {
    jobInfo: "E-584: Nick & Cheyenne  Consoli",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 4971.00,
    grossMarginPct: 0.4143,
    grossProfit: 2059.49,
    commissionPercentage: 4.00,
    salesCommission: 198.84,
    salesManagerFee: 49.71,
    companyOH: 770.51,
    netProfit: 0
  },
  {
    jobInfo: "E-558: Kimberly Briscoe",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 17500.00,
    grossMarginPct: 0.4410,
    grossProfit: 7717.50,
    commissionPercentage: 4.00,
    salesCommission: 700.00,
    salesManagerFee: 175.00,
    companyOH: 2712.50,
    netProfit: 0
  },
  {
    jobInfo: "E-540: Butch & Cynthia Ewing",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 4316.00,
    grossMarginPct: 0.5925,
    grossProfit: 2557.23,
    commissionPercentage: 7.00,
    salesCommission: 302.12,
    salesManagerFee: 43.16,
    companyOH: 668.98,
    netProfit: 0
  },
  {
    jobInfo: "E-581: Daiana & Marian But",
    leadSource: "Facebook / Meta Ads",
    trade: "Attic Insulation",
    contractTotal: 5500.00,
    grossMarginPct: 0.4599,
    grossProfit: 2529.45,
    commissionPercentage: 4.00,
    salesCommission: 220.00,
    salesManagerFee: 55.00,
    companyOH: 852.50,
    netProfit: 0
  },
  {
    jobInfo: "E-571: Erin Brown",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 1972.00,
    grossMarginPct: 0.5653,
    grossProfit: 1114.77,
    commissionPercentage: 7.00,
    salesCommission: 138.04,
    salesManagerFee: 19.72,
    companyOH: 305.66,
    netProfit: 0
  },
  {
    jobInfo: "E-553: Tim & Avery Crisp",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 9872.00,
    grossMarginPct: 0.4214,
    grossProfit: 4160.06,
    commissionPercentage: 4.00,
    salesCommission: 394.88,
    salesManagerFee: 98.72,
    companyOH: 1530.16,
    netProfit: 0
  },
  {
    jobInfo: "E-536: Henry Adeyeri",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 3992.00,
    grossMarginPct: 0.4000,
    grossProfit: 1596.80,
    commissionPercentage: 4.00,
    salesCommission: 159.68,
    salesManagerFee: 39.92,
    companyOH: 618.76,
    netProfit: 0
  },
  {
    jobInfo: "E-537: Nancy Teresa Oliver",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 1130.00,
    grossMarginPct: 0.4939,
    grossProfit: 558.11,
    commissionPercentage: 4.00,
    salesCommission: 45.20,
    salesManagerFee: 11.30,
    companyOH: 175.15,
    netProfit: 0
  },
  {
    jobInfo: "E-526: Omar & Nancita Loutan",
    leadSource: "Thumbtack",
    trade: "Gutters",
    contractTotal: 1616.00,
    grossMarginPct: 0.5045,
    grossProfit: 815.27,
    commissionPercentage: 7.00,
    salesCommission: 113.12,
    salesManagerFee: 16.16,
    companyOH: 250.48,
    netProfit: 0
  },
  {
    jobInfo: "E-531: Theodore & Karen Page",
    leadSource: "Previous Customer",
    trade: "Gutters",
    contractTotal: 1856.00,
    grossMarginPct: 0.6578,
    grossProfit: 1220.88,
    commissionPercentage: 10.00,
    salesCommission: 185.60,
    salesManagerFee: 18.56,
    companyOH: 287.68,
    netProfit: 0
  },
  {
    jobInfo: "E-539: Philip & Keyara Coleman",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 2282.00,
    grossMarginPct: 0.4896,
    grossProfit: 1117.27,
    commissionPercentage: 4.00,
    salesCommission: 91.28,
    salesManagerFee: 22.82,
    companyOH: 353.71,
    netProfit: 0
  },
  {
    jobInfo: "E-524: Lauren Moscato",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 3472.00,
    grossMarginPct: 0.5253,
    grossProfit: 1823.84,
    commissionPercentage: 7.00,
    salesCommission: 243.04,
    salesManagerFee: 34.72,
    companyOH: 538.16,
    netProfit: 0
  },
  {
    jobInfo: "Nita & Ahkeem Brown",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 6780.00,
    grossMarginPct: 0.4000,
    grossProfit: 2712.00,
    commissionPercentage: 4.00,
    salesCommission: 271.20,
    salesManagerFee: 67.80,
    companyOH: 1050.90,
    netProfit: 0
  },
  {
    jobInfo: "Vartan Zenian",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 9450.00,
    grossMarginPct: 0.4000,
    grossProfit: 3780.00,
    commissionPercentage: 4.00,
    salesCommission: 378.00,
    salesManagerFee: 94.50,
    companyOH: 1464.75,
    netProfit: 0
  },
  {
    jobInfo: "William & Lindsey Dargusch",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 28812.00,
    grossMarginPct: 0.4000,
    grossProfit: 11524.80,
    commissionPercentage: 4.00,
    salesCommission: 1152.48,
    salesManagerFee: 288.12,
    companyOH: 4465.86,
    netProfit: 0
  },
  {
    jobInfo: "John & Laimon Cannon",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 17221.00,
    grossMarginPct: 0.4000,
    grossProfit: 6888.40,
    commissionPercentage: 4.00,
    salesCommission: 688.84,
    salesManagerFee: 172.21,
    companyOH: 2669.26,
    netProfit: 0
  },
  {
    jobInfo: "E-555: Crystal Bolden",
    leadSource: "Thumbtack",
    trade: "Gutters",
    contractTotal: 4061.00,
    grossMarginPct: 0.5125,
    grossProfit: 2081.26,
    commissionPercentage: 7.00,
    salesCommission: 284.27,
    salesManagerFee: 40.61,
    companyOH: 629.46,
    netProfit: 0
  },
  {
    jobInfo: "E-567: Eduardo Howell-Rose",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 2473.00,
    grossMarginPct: 0.6228,
    grossProfit: 1540.18,
    commissionPercentage: 10.00,
    salesCommission: 247.30,
    salesManagerFee: 24.73,
    companyOH: 383.32,
    netProfit: 0
  },
  {
    jobInfo: "E-560: Alan & Tamera Crane",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 11062.00,
    grossMarginPct: 0.4676,
    grossProfit: 5172.59,
    commissionPercentage: 4.00,
    salesCommission: 442.48,
    salesManagerFee: 110.62,
    companyOH: 1714.61,
    netProfit: 0
  },
  {
    jobInfo: "E-577: Vernon Thomas",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 26500.00,
    grossMarginPct: 0.5037,
    grossProfit: 13348.05,
    commissionPercentage: 7.00,
    salesCommission: 1855.00,
    salesManagerFee: 265.00,
    companyOH: 4107.50,
    netProfit: 0
  },
  {
    jobInfo: "E-579: Liliam & Kaylee Villarroel saltos",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 2500.00,
    grossMarginPct: 0.5150,
    grossProfit: 1287.50,
    commissionPercentage: 7.00,
    salesCommission: 175.00,
    salesManagerFee: 25.00,
    companyOH: 387.50,
    netProfit: 0
  },
  {
    jobInfo: "E-590: Eric & Maria Metee",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 2472.00,
    grossMarginPct: 0.1880,
    grossProfit: 464.74,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 24.72,
    companyOH: 383.16,
    netProfit: 0
  },
  {
    jobInfo: "E-538: Keegan & John Hooks",
    leadSource: "Previous Customer",
    trade: "Attic Insulation",
    contractTotal: 5050.00,
    grossMarginPct: 0.6104,
    grossProfit: 3082.52,
    commissionPercentage: 10.00,
    salesCommission: 505.00,
    salesManagerFee: 50.50,
    companyOH: 782.75,
    netProfit: 0
  },
  {
    jobInfo: "E-532: Joel & Angela Hersh",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 13797.00,
    grossMarginPct: 0.5096,
    grossProfit: 7030.95,
    commissionPercentage: 7.00,
    salesCommission: 965.79,
    salesManagerFee: 137.97,
    companyOH: 2138.54,
    netProfit: 0
  }
];

// Apply business logic to calculate net profit (Standard Report formula)
jobData.forEach(job => {
  // For Standard Reports: Net Profit = Gross Profit - (Sales Commission + Sales Manager Fee + Company OH)
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);
const totalManagerFees = jobData.reduce((sum, job) => sum + job.salesManagerFee, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);

// Ad spend data from CSV
const adSpendData = [
  { source: "Networx", spend: 2182.00 },
  { source: "Thumbtack", spend: 11921.00 },
  { source: "Yelp", spend: 7920.00 },
  { source: "Porch", spend: 287.16 },
  { source: "Web to Lead Form", spend: 4650.00 },
  { source: "Angi", spend: 2530.00 },
  { source: "Homebuddy", spend: 10906.00 },
  { source: "Buyerlink", spend: 1010.00 },
  { source: "Google Organic Search", spend: 3500.00 },
  { source: "Google Paid Search", spend: 1996.47 },
  { source: "Facebook / Meta Ads", spend: 3927.92 },
  { source: "BBB", spend: 300.00 }
];

const totalAdSpend = adSpendData.reduce((sum, item) => sum + item.spend, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

// Create the final report data object
export const augustData: ReportData = {
  kpis: {
    // Total ad spend
    adSpend: totalAdSpend,

    // Sum of all contract totals
    totalSales: totalContractValue,

    // Sum of all gross profits
    grossProfit: totalGrossProfit,

    // Sum of all sales commissions
    salesCommissions: totalSalesCommissions,

    // Sum of all manager fees
    managerFees: totalManagerFees,

    // Company overhead
    companyOH: totalCompanyOH,

    // Net profit (standard calculation) minus ad spend
    netProfit: totalNetProfit - totalAdSpend,

    // Net profit as percentage of total sales
    netProfitPercent: (totalNetProfit - totalAdSpend) / totalContractValue,

    // Gross profit as percentage of total sales
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  // Ad spend by source with all sources
  adSpendBySource: adSpendData,

  // Sales by lead source - aggregated above
  salesBySource: salesBySource,

  // Sales by trade - aggregated above
  salesByTrade: salesByTrade,

  // Individual job data
  jobData: jobData,

  // Report period information
  period: {
    month: 8, // August
    year: 2025
  }
};